import { render, staticRenderFns } from "./TheArticle.vue?vue&type=template&id=f7e3b636&"
import script from "./TheArticle.vue?vue&type=script&lang=js&"
export * from "./TheArticle.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./TheArticle.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "199e1468"
  
)

component.options.__file = "TheArticle.vue"
export default component.exports